import ErrorCode404 from "../Pages/404/index.svelte"
import Login from "../Pages/Login/index.svelte"
import DocumentList from "../Pages/Templates/Documents/List/index.svelte"
import DocumentEdit from "../Pages/Templates/Documents/Edit/index.svelte"
import EmailEdit from "../Pages/Templates/Email/Edit/index.svelte"
import EmailList from "../Pages/Templates/Email/List/index.svelte"
import SettingsSecuity from "../Pages/Settings/Security/index.svelte"
import Home from "../Pages/Settings/Integration/Components/home.svelte"
import Authenticator from "../Pages/Settings/Integration/Components/authenticator.svelte"
import scanQR from "../Pages/Settings/Integration/Components/scanQR.svelte"
import Success from "../Pages/Settings/Integration/Components/success.svelte"
import Verify from "../Pages/Settings/Integration/Components/verify.svelte"
// import SettingsConfiguration from "../Pages/Settings/Configuration/index.svelte"

// Badge
import BadgeStartPage from "../Pages/Publish/Badge/Pages/StartPage/index.svelte"
import docTemplateSelection from "../Pages/Publish/Badge/Pages/docTemplateSelection/index.svelte"
import badgeTemplateSelection from "../Pages/Publish/Badge/Pages/badgeTemplateSelection/index.svelte"
import BadgeMetadata from "../Pages/Publish/Badge/Pages/Metadata/index.svelte"
import BatchFileUpload from "../Pages/Publish/Badge/Pages/GenerateFile/index.svelte"
import BatchPreview from "../Pages/Publish/Badge/Pages/Preview/index.svelte"
import BatchFinal from "../Pages/Publish/Badge/Pages/FinalPage/index.svelte"

//singlePublish
import StartPage from "../Pages/Publish/SinglePublish/pages/startPage.svelte"
import ChooseDocTemp from "../Pages/Publish/SinglePublish/pages/chooseDocTemp.svelte"
import DocUpload from "../Pages/Publish/SinglePublish/pages/documentUpload.svelte"
import DocMetadata from "../Pages/Publish/SinglePublish/pages/DocMetadata.svelte"
import DocPreview from "../Pages/Publish/SinglePublish/pages/DocPreview.svelte"
import QRCodePreview from "../Pages/Publish/SinglePublish/pages/qrCodePreview.svelte"

// file template section
import documentItems from "../Pages/Templates/File/list/index.svelte"
import uploadBaseImage from "../Pages/Templates/File/Edit/Index.svelte"

// history
import History from "../Pages/History/Document/index.svelte"
import Pending from "../Pages/History/PendingDocument/index.svelte"
import SecureAccess from "../Pages/History/Document_Control/index.svelte"
import BulkUpload from "../Pages/Publish/BulkUpload/Pages/UploadArea/index.svelte"
import InvalidAccordion from "../Pages/Publish/BulkUpload/Pages/InvalidAccordion/index.svelte"
import Session from "../Pages/Publish/BulkUpload/Pages/SessionDetails/index.svelte"
import FileGeneration from "../Pages/Publish/BulkUpload/Pages/GenerateFile/index.svelte"
import Badges from "../Pages/History/Badges/index.svelte"

import SignAndPublish from "../Pages/Publish/BulkUpload/Pages/SignAndPublish/index.svelte"
import Report from "../Pages/Publish/BulkUpload/Pages/Report/index.svelte"
import Email from "../Pages/Publish/BulkUpload/Pages/Email/index.svelte"
import Revoke from "../Pages/Publish/BulkUpload/Pages/RevokeDocument/index.svelte"
import passwordSuccseccPage from "../Pages/Settings/Security/Components/successPage.svelte"
//Analytics
import DocAnalytics from "../Pages/Analytics/Document/index.svelte"
import EmailAnalytics from "../Pages/Analytics/Email/index.svelte"
import SinDocAnalytics from "../Pages/Analytics/SinDocAnalytics/index.svelte"
import UploadFiles from "../Pages/Publish/BulkUpload/Pages/UploadFiles/index.svelte"
import BulkHistory from "../Pages/History/BulkUpload/index.svelte"
import SendEmail from "../Pages/Analytics/ComposeEmail/index.svelte"

//Badge
import BadgeItems from "../Pages/Templates/Badge/List/index.svelte"
import BadgeEdit from "../Pages/Templates/Badge/Edit/index.svelte"
import BadgeDetails from "../Pages/Publish/Badge/Pages/FinalPage/index.svelte"

import MSignerStartPage from "../Pages/Signing/MultiSigner/Pages/StartPage/index.svelte"
import CreateDocket from "../Pages/Signing/MultiSigner/Pages/CreateDocket/index.svelte"
import Docket from "../Pages/Signing/Docket/index.svelte"
import SingleDocket from "../Pages/Signing/SingleDocket/index.svelte"

//Settings Signer
import AddSigner from "../Pages/Signing/Signer/AddSigner/index.svelte"
import SignerList from "../Pages/Signing/Signer/SignerList/index.svelte"
import Seal from "../Pages/Signing/Seal/List/index.svelte"
import AddSeal from "../Pages/Signing/Seal/Edit/index.svelte"

export default {
  "/": Login,

  // signing
  "/signing/multiSigner": MSignerStartPage,
  "/signing/multiSigner/docket": CreateDocket,
  "/signing/dockets": Docket,
  "/signing/single/docket": SingleDocket,
  "/signing/signer": SignerList,
  "/signing/seal": Seal,
  "/signing/seal/edit": AddSeal,
  "/signing/signer/add": AddSigner,

  //Badge
  "/templates/badge": BadgeItems,
  "/templates/badge/edit": BadgeEdit,

  "/templates/document": DocumentList,
  "/templates/document/edit": DocumentEdit,
  "/templates/email": EmailList,
  "/templates/email/edit": EmailEdit,
  // file template
  "/templates/file": documentItems,
  "/templates/file/edit": uploadBaseImage,
  "/settings/security": SettingsSecuity,
  "/settings/security/success": passwordSuccseccPage,
  "/settings/integration/home": Home,
  "/settings/integration/authenticator": Authenticator,
  "/settings/integration/authenticator/success": Success,
  "/settings/integration/authenticator/scanQR": scanQR,
  "/settings/integration/authenticator/verify": Verify,
  // "/settings/configuration": SettingsConfiguration,
  "/publish/badge": BadgeStartPage,
  "/publish/badge/badgetemplate": badgeTemplateSelection,
  "/publish/badge/doctemplate": docTemplateSelection,
  "/publish/badge/metadata": BadgeMetadata,
  "/publish/badge/upload": BatchFileUpload,
  "/publish/badge/preview": BatchPreview,
  // "/publish/badge/final": BatchFinal,

  "/publish/single": StartPage,
  "/publish/single/choose_template": ChooseDocTemp,
  "/publish/single/upload_document": DocUpload,
  "/publish/single/metadata": DocMetadata,
  "/publish/single/preview": DocPreview,
  "/publish/single/qrcode": QRCodePreview,
  "/publish/bulk": BulkUpload,
  "/publish/bulk/invalid": InvalidAccordion,
  "/publish/bulk/generate-file": FileGeneration,
  "/publish/bulk/upload-file": UploadFiles,
  "/publish/bulk/sign-publish": SignAndPublish,
  "/documents/bulk/view-report": Report,
  "/publish/bulk/revoke": Revoke,
  "/publish/bulk/send-email": Email,
  "/publish/bulk/session": Session,
  "/documents/single": History,
  "/documents/bulk": BulkHistory,
  "/documents/pending": Pending,
  "/documents/badge": Badges,
  "/documents/badge/details": BadgeDetails,

  "/documents/single/secure_access": SecureAccess,
  //Analytics
  "/analytics/documents": DocAnalytics,
  "/analytics/email": EmailAnalytics,
  "/analytics/documents/single": SinDocAnalytics,
  "/analytics/documents/send-email": SendEmail,

  // The catch-all route must always be last
  "*": ErrorCode404,
}
